import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "78",
  height: "93",
  viewBox: "0 0 78 93"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EAEAEA",
      "fill-rule": "evenodd",
      d: "M30 0h18c16.569 0 30 13.431 30 30v18c0 16.569-13.431 30-30 30H30C13.431 78 0 64.569 0 48V30C0 13.431 13.431 0 30 0zm-9 39a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm36 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
    }, null, -1)
  ]))]))
}
export default { render: render }